import { createSelector } from 'reselect'
import moment from 'moment'

const normalizeParticipant = createSelector(
  state => state.api.payment.participant.data,
  participant => {
    if (!participant) {
      return
    }

    const normalized = { ...participant }

    normalized.name = [
      participant.firstName,
      participant.middleName,
      participant.lastName
    ].join(' ')

    normalized.birthDate = moment(participant.birthDate).calendar()

    normalized.address = [
      participant.line1,
      participant.line2,
      participant.city,
      participant.zipCode,
      participant.stateOrProvinceOrRegion
    ]
      .filter(val => Boolean(val))
      .join(', ')

    normalized.postalAddress = [
      participant.postalLine1,
      participant.postalLine2,
      participant.postalCity,
      participant.postalZipCode,
      participant.postalStateOrProvinceOrRegion
    ]
      .filter(val => Boolean(val))
      .join(', ')

    const nestedValues = [
      'awardLevel',
      'gender',
      'nationality',
      'employmentStatus'
    ]

    nestedValues.map(
      item =>
        normalized[item] = normalized[item]
          ? normalized[item].translationText
          : '---'
    )

    return normalized
  }
)

export default normalizeParticipant
